import React, { memo } from 'react';
import { TextField } from '@material-ui/core';
import { CustomFormControlProps, CustomInputType, CustomTextareaType } from '../../../model/global';
import { getPrefixedFieldId } from '../../utils';
import { useSelector } from 'react-redux';
import { translationsSelector } from '../../../store/modules/translations/selectors';
import useStyles from './styles';


const InputBox: React.FC<CustomFormControlProps> = ({ field, onChange, fullWidth, validationError }): JSX.Element => {
	const classes = useStyles();
	const { formRequiredField } = useSelector(translationsSelector)

	const [validationMessageState, setValidationMessageState] = React.useState('');

	const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, _field: CustomInputType | CustomTextareaType): void => {
		const {
			name,
			value,
			required,
			validity: { valid },
		} = event.target;

		if (valid === false) {
			setValidationMessageState(formRequiredField || 'This field is required');
		} else {
			setValidationMessageState('');
		}

		onChange({
			name,
			value,
			required,
			valid,
			invalidReason: field.invalidReason || '',
			originalField: _field,
		});
	};

	/** Support for external field validation messages */
	const getHelperText = (): string => {
		return validationError || validationMessageState || '';
	}

	const controlId = getPrefixedFieldId(field.originalField.id || field.originalField.name);

	return (
		<TextField
			label={field.originalField?.title || ''}
			className={classes.inputText}
			variant="outlined"
			fullWidth={!!fullWidth === false}
			name={field.name}
			id={controlId}
			margin={'none'}
			type={field.originalField?.fieldType || 'text'}
			style={{
				marginLeft: 0,
				marginRight: 0,
			}}
			InputLabelProps={{
				shrink: true,
			}}
			value={field.value}
			helperText={getHelperText()}
			error={getHelperText() !== ''}
			FormHelperTextProps={
				{
					className: classes.validationWrapper
				}
			}
			required={field.required}
			onChange={(e) => handleTextFieldChange(e, field.originalField as CustomInputType)}
			// support for text areas
			multiline={field.originalField?.fieldType === 'textarea'}
			minRows={field.originalField?.fieldType === 'textarea' ? ((field.originalField as CustomTextareaType).minRows || 5) : 1}
			maxRows={field.originalField?.fieldType === 'textarea' ? ((field.originalField as CustomTextareaType).maxRows || 8) : 1}
		/>
	);
};

export default memo(InputBox);
